import React from 'react';
import type {
  CompareEntitiesContextProps,
  CompareEntitiesFormsProps,
} from '../types';
import {
  CollapseContext,
  useCollapseContextProviderValue,
} from '../context/CollapseContext';
import {
  CompareEntitiesContext,
  useCompareEntitiesContextProviderValue,
} from '../context/CompareEntitiesContext';
import {CompareEntitiesCore} from './CompareEntitiesCore';

type CompareEntitiesProps = {
  compareEntitiesContextProps: CompareEntitiesContextProps;
  compareEntitiesFormProps: CompareEntitiesFormsProps;
};

export const CompareEntities: React.FC<CompareEntitiesProps> = ({
  compareEntitiesContextProps,
  compareEntitiesFormProps,
}) => {
  const provider = useCompareEntitiesContextProviderValue(
    compareEntitiesContextProps,
  );
  const collapseProvider = useCollapseContextProviderValue(
    (compareEntitiesFormProps?.additionalComparisons ?? []).length > 0,
  );

  return (
    <CompareEntitiesContext value={provider}>
      <CollapseContext value={collapseProvider}>
        <CompareEntitiesCore {...compareEntitiesFormProps} />
      </CollapseContext>
    </CompareEntitiesContext>
  );
};
